var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8925 0.558672L0.5625 0.558672L0.5625 31.8887H31.8925V0.558672Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5505 10.2417L18.3285 8.01967L10.1285 16.2197L18.3285 24.4197L20.5505 22.1977L14.5655 16.2257L20.5505 10.2417Z",
    fill: "#686868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronGray);
export default __webpack_public_path__ + "static/media/Chevron-Gray.ec1c285f995e5679b2b66f18f4cccfdc.svg";
export { ForwardRef as ReactComponent };